import { render, staticRenderFns } from "./ItemSummaryRow.vue?vue&type=template&id=5c8ad52e"
import script from "./ItemSummaryRow.vue?vue&type=script&lang=js"
export * from "./ItemSummaryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports